/*
  SINGLE SOURCE OF TRUTH for languages.
  To add a language: add ONE entry here + ONE matching locale JSON file in
  ./locales/<code>.json. No component changes are required anywhere.

  Fields:
  - code:    locale/language code (also the URL prefix for non-default langs)
  - name:    language name written in its own language (shown in the switcher)
  - flag:    ISO country code for the flag icon (flag-icons); country, not language
  - dir:     text direction 'ltr' | 'rtl'
  - enabled: whether it appears in the switcher / gets routes + hreflang
  - default: exactly one entry is the default (unprefixed) language
*/
export const LOCALES = [
  // ---- Enabled (order defines switcher + route order) ----
  { code: "en", name: "English", flag: "US", dir: "ltr", enabled: true, default: true },
  { code: "es", name: "Español", flag: "ES", dir: "ltr", enabled: true },
  { code: "zh", name: "简体中文", flag: "CN", dir: "ltr", enabled: true },
  { code: "ja", name: "日本語", flag: "JP", dir: "ltr", enabled: true },
  { code: "pt", name: "Português", flag: "BR", dir: "ltr", enabled: true },
  { code: "fr", name: "Français", flag: "FR", dir: "ltr", enabled: true },
  { code: "it", name: "Italiano", flag: "IT", dir: "ltr", enabled: true },
  { code: "ro", name: "Română", flag: "RO", dir: "ltr", enabled: true },
  { code: "sk", name: "Slovenčina", flag: "SK", dir: "ltr", enabled: true },
  { code: "de", name: "Deutsch", flag: "DE", dir: "ltr", enabled: true },

  // ---- Present but disabled (kept for possible future use) ----
  { code: "ar", name: "العربية", flag: "SA", dir: "rtl", enabled: false },
  { code: "hi", name: "हिन्दी", flag: "IN", dir: "ltr", enabled: false },
  { code: "id", name: "Bahasa Indonesia", flag: "ID", dir: "ltr", enabled: false },
];
